var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-navbar gfu-navbar--lighter gfu-navbar--elevate _jc-c" },
    [
      _c(
        "div",
        {
          staticClass:
            "gfu-navbar-nav gfu-navbar-nav--scrollable gfu-navbar-nav--secondary",
        },
        [
          _c(
            "div",
            { staticClass: "gfu-navbar-nav__wrapper" },
            _vm._l(_vm.navigationItems, function (item) {
              return _c(
                "div",
                {
                  key: item.pageName,
                  ref: item.ref,
                  refInFor: true,
                  class: item.classes,
                  attrs: { "data-qa": `slider-navigation:${item.pageName}` },
                },
                [
                  _c(
                    "base-link",
                    {
                      staticClass: "gfu-navbar-link",
                      attrs: { url: item.url },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }